import { render, staticRenderFns } from "./DialogShowFile.vue?vue&type=template&id=235a157b&scoped=true&"
import script from "./DialogShowFile.vue?vue&type=script&lang=js&"
export * from "./DialogShowFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235a157b",
  null
  
)

export default component.exports